import { render, staticRenderFns } from "./EditTournament.vue?vue&type=template&id=08839c30&scoped=true"
import script from "./EditTournament.vue?vue&type=script&lang=js"
export * from "./EditTournament.vue?vue&type=script&lang=js"
import style0 from "./EditTournament.vue?vue&type=style&index=0&id=08839c30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08839c30",
  null
  
)

export default component.exports